import { StiffenersSettings } from "src/app/automatic-points/_models/StiffenersSettings"
import { GeneralSettings } from "src/app/automatic-points/_models/GeneralSettings"
import { PlatesSettings } from "src/app/automatic-points/_models/PlatesSettings"
import { FacePlatesSettings } from "src/app/automatic-points/_models/FacePlatesSettings"
import { BracketSettings } from "src/app/automatic-points/_models/BracketSettings"
import { AreaSettings } from "src/app/automatic-points/_models/AreaSettings"
import { ICheckList } from "../automatic-plan-type-selector/automatic-plan-type-selector.component"

export class AutomaticPoints {
    Id: string;
    AssetId: string;
    CollectionId: string;
    Label: string;
    Date: Date;
    AreaSettings: AreaSettings;
    GeneralSettings: GeneralSettings;
    PlatesSettings: PlatesSettings;
    StiffenersSettings: StiffenersSettings;
    FacePlatesSettings: FacePlatesSettings;
    BracketSettings: BracketSettings;
    UserId: string;
    InspectionTypeId: string;
    InspectionMethodId: string;
    InspectionTypeName: string;
    InspectionTypeAlias: string;
    CheckLists: ICheckList[]
    /** Where the day is in several open plans, the one the user chose for the new points. */
    PreferredPlanIds?: string[]
}



